export const PROFILE_CACHE_KEYS = {
  profile: 'profile'
};
